import React from 'react';
import { Tooltip } from '@ui';
/**
 * Inline status icon for the "Retrieve from QB" import table: marks a QBO item
 * whose Inspect Point record already exists but is deactivated — importing it
 * reactivates the existing record in place instead of creating a duplicate.
 *
 * Mounted per-row by the legacy DataTable via react_ujs data-react-class
 * markup (see app/assets/javascripts/proposed_corrections.js), so it must
 * stay a self-contained island: label/tooltip strings arrive pre-translated
 * from the controller.
 */
function QbImportStatusIcon({ label, tooltip }) {
    return (React.createElement(Tooltip, { content: tooltip, multiline: true },
        React.createElement("span", { className: "qb-import-status-icon", role: "img", "aria-label": label }, "\u21BA")));
}
export default QbImportStatusIcon;
